import { BreadcrumbJsonLd } from 'next-seo';

import { toAbsoluteLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';
import LINKS from 'constants/links';

const CouponsSchema = () => (
  <BreadcrumbJsonLd
    itemListElements={[
      {
        position: 1,
        name: placeholder('breadcrumbs.app'),
        item: APP.URL,
      },
      {
        position: 2,
        name: placeholder('breadcrumbs.coupons'),
        item: toAbsoluteLink(LINKS.COUPONS),
      },
    ]}
  />
);

export default CouponsSchema;
